import { useQuery } from "@tanstack/react-query";

import { AdminCoverCropDetection, getFarmCoverCropDetections } from "services";

import { GET_FARM_COVER_CROP_DETECTIONS } from "consts";

export const useGetFarmCoverCropDetections = ({ farmId }: { farmId: string }) =>
  useQuery<AdminCoverCropDetection[]>({
    queryKey: [GET_FARM_COVER_CROP_DETECTIONS, farmId],
    queryFn: () => getFarmCoverCropDetections({ farmId }),
    enabled: !!farmId,
    staleTime: 1000 * 60 * 5, // reruns and backfill results show up on the next visit or tab focus
  });
